import { axiosInstance } from '@/modules/shared/lib/axios'
import {
  FetchExpectedNettoFromEasyTmsRequest,
  FetchExpectedNettoFromEasyTmsResponse,
} from './types'

export function fetchExpectedNettoFromEasyTms({
  companyId,
  ...body
}: FetchExpectedNettoFromEasyTmsRequest) {
  return axiosInstance.post<FetchExpectedNettoFromEasyTmsResponse>(
    `/api/${companyId}/timesheet/expectedNettoFromEasyTms`,
    body,
  )
}
